import React, {useCallback, useEffect, useLayoutEffect, useState} from 'react';
import {
  View,
  Platform,
  ScrollView,
  TouchableWithoutFeedback,
} from 'react-native';

import HTML from 'react-native-render-html';

import {useFocusEffect, useNavigation} from '@react-navigation/native';

import {StyleSheet} from 'react-native';
import {colorPalette} from '../../../core/config/color.config';

import {RNEText, SVGIcon} from '../../components';
import HeaderBackLeft from '../../views/navigation/HeaderBackLeft';
import {width, height, totalSize} from 'react-native-dimension';

import {HTMLPrivacyPolicy} from './../../data/policy/privacy-policy';
import {
  BUILD_NUMBER,
  MAJOR_VERSION,
  MINOR_VERSION,
} from '../../server/api/api.config';
import {usePullDownRefreshContext} from '../../stores/pullDownRefreshStore';
import useStores from '../../stores/useStores';
import {NavigationKey} from '../../navigations/config';
import { observer } from 'mobx-react';

const PrivacyPolicyScreen = () => {
  const navigation = useNavigation();
  const {setCanRefresh} = usePullDownRefreshContext();

  const {authStore} = useStores();

  useLayoutEffect(() => {
    navigation.setOptions(
      Platform.OS === 'web'
        ? {
            headerShown: false,
          }
        : {
            headerShown: true,
            title: '',
            headerStyle: {
              elevation: 0,
              shadowOpacity: 0,
            },
            headerTintColor: colorPalette.blackLight,
            headerTitleStyle: {
              fontFamily: 'Quicksand-Regular',
              fontSize: 14,
              paddingLeft: 28,
            },
            headerLeft: () => <HeaderBackLeft removeLabel />,
            headerRight: () => null,
          },
    );
  }, [navigation]);

  const [scrollViewHeight, setScrollViewHeight] = useState(0);
  const [contentHeight, setContentHeight] = useState(0);
  const [scrollY, setScrollY] = useState(0);
  const isLogggedInUser = !!authStore?.auth?.token;

  useFocusEffect(
    useCallback(() => {
      if (scrollViewHeight > 0 && contentHeight > 0) {
        const isScrollable = contentHeight > scrollViewHeight;

        if (!isScrollable) {
          setCanRefresh(true); // always allow pull-down if not scrollable
        } else {
          setCanRefresh(scrollY <= 0); // only allow when scrolled to top
        }
      }
    }, [scrollViewHeight, contentHeight, scrollY, setCanRefresh]),
  );
  const handleScroll = (e: any) => {
    const y = e.nativeEvent.contentOffset.y;
    setScrollY(y);

    const isScrollable = contentHeight > scrollViewHeight;

    if (!isScrollable) {
      setCanRefresh(true); // still always true if no scroll
    } else {
      setCanRefresh(y <= 0); // only true when back at the very top
    }
  };

   



  return (
    <>
      {Platform.OS === 'web' ? (
        <View
          style={[
            webStyles.mainContainer,
            {padding: totalSize(1)},
          ]}>
          <View style={webStyles.titleContainer}>
            {/* {isLogggedInUser && (
              <TouchableWithoutFeedback onPress={() => navigation.goBack(-1)}>
                <View
                  style={webStyles.backContainer}
                  accessibilityRole="button">
                  <SVGIcon name="left-black" size={24} />
                </View>
              </TouchableWithoutFeedback>
            )} */}

            

            <RNEText
              label="Privacy Policy"
              variant="header"
              weight="bold"
              color="accent"
            />
          </View>
          <ScrollView style={webStyles.mainWrapper}>
            <HTML
              source={{
                html: HTMLPrivacyPolicy,
              }}
            />
          </ScrollView>
          <View style={webStyles.versionContainer}>
            <RNEText
              label={`House Call version ${MAJOR_VERSION}.${MINOR_VERSION}.${BUILD_NUMBER}`}
              variant="title"
              weight="bold"
              color="accent"
              align="right"
              // eslint-disable-next-line react-native/no-inline-styles
              style={{fontSize: 16}}
            />
          </View>
        </View>
      ) : (
        <>
          <ScrollView
            onScroll={handleScroll}
            onLayout={e => {
              setScrollViewHeight(e.nativeEvent.layout.height);
            }}
            onContentSizeChange={(contentWidth, contentHeight) => {
              setContentHeight(contentHeight);
            }}>
            <View style={mobileStyles.mainContainer}>
              <RNEText
                label="Privacy Policy"
                variant="header"
                weight="bold"
                color="accent"
                style={{fontSize: totalSize(2.8), marginLeft: -width(1.5)}}
              />

              <HTML
                baseStyle={{fontSize: totalSize(1.8)}}
                defaultTextProps={{
                  allowFontScaling: false,
                }}
                source={{
                  html: HTMLPrivacyPolicy,
                }}
              />
            </View>
          </ScrollView>

          <View style={mobileStyles.versionContainer}>
            <RNEText
              label={`House Call version ${MAJOR_VERSION}.${MINOR_VERSION}.${BUILD_NUMBER}`}
              variant="title"
              weight="bold"
              color="accent"
              align="right"
              // eslint-disable-next-line react-native/no-inline-styles
              style={{fontSize: totalSize(1.5)}}
            />
          </View>
        </>
      )}
    </>
  );
};

// export default PrivacyPolicyScreen;
export default observer(PrivacyPolicyScreen);

const webStyles = StyleSheet.create({
  mainContainer: {
    paddingTop: 140,
    paddingBottom: 32,
    paddingHorizontal: 80,
    width: '100%',
    flex: 1,
  },
  titleContainer: {
    marginBottom: 40,
    flexDirection: 'row',
  },
  mainWrapper: {
    paddingRight: 48,
  },
  versionContainer: {
    marginTop: 20,
  },
  backContainer: {
    marginRight: 16,
    justifyContent: 'center',
  },
});

const mobileStyles = StyleSheet.create({
  mainContainer: {
    paddingVertical: totalSize(0),
    paddingHorizontal: totalSize(2.5),
  },
  versionContainer: {
    marginRight: width(4),
    marginTop: width(5),
    marginBottom: width(5),
  },
});
